// extracted by mini-css-extract-plugin
export default {"Wrapper":"styles_Wrapper__BQlHy"};